export default __webpack_public_path__ + "static/media/lounge-waiting.e4cb860c.jpg";